import React from 'react';
import './switch.css';

/**
 * Composant Switch moderne - Alternative élégante aux cases à cocher
 * 
 * @param {boolean} checked - État du switch (activé/désactivé)
 * @param {function} onChange - Fonction appelée lors du changement d'état
 * @param {string} label - Label du switch
 * @param {string} size - Taille du switch ('sm', 'md', 'lg')
 * @param {string} color - Couleur du switch ('primary', 'success', 'warning', 'danger')
 * @param {boolean} disabled - Si le switch est désactivé
 * @param {string} labelPosition - Position du label ('left', 'right')
 */
const Switch = ({ 
  checked = false,
  onChange,
  label,
  size = 'md',
  color = 'primary',
  disabled = false,
  labelPosition = 'right',
  ...props 
}) => {
  const handleChange = (e) => {
    if (!disabled && onChange) {
      onChange(e.target.checked);
    }
  };

  const switchClass = `
    modern-switch 
    modern-switch--${size} 
    modern-switch--${color}
    ${disabled ? 'modern-switch--disabled' : ''}
    ${checked ? 'modern-switch--checked' : ''}
  `.trim();

  const labelElement = label && (
    <span className="modern-switch__label">
      {label}
    </span>
  );

  return (
    <label className="modern-switch-wrapper" {...props}>
      {labelPosition === 'left' && labelElement}
      
      <div className={switchClass}>
        <input
          type="checkbox"
          className="modern-switch__input"
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
        />
        <span className="modern-switch__slider">
          <span className="modern-switch__thumb"></span>
        </span>
      </div>
      
      {labelPosition === 'right' && labelElement}
    </label>
  );
};

export default Switch;
